// extracted by mini-css-extract-plugin
export var item = "styles-module--item--htk59";
export var content = "styles-module--content--TpH67";
export var owner = "styles-module--owner--3n0x2";
export var left = "styles-module--left--Q2h+g";
export var avatars = "styles-module--avatars--Xb2jp";
export var avatar = "styles-module--avatar--Sjb5j";
export var name = "styles-module--name--Wxjj-";
export var info = "styles-module--info--l--Bl";